import { useCallback, useEffect, useState } from 'react';
import { learningApi } from '../api/learning';
import { ApiError } from '../api/client';
import { localDateKey } from '../shared/date';
import type { AttemptInput, ProgressSummary } from '../types/api';

export function useProgress(enabled: boolean, onUnauthorized: () => void) {
  const [progress, setProgress] = useState<ProgressSummary | null>(null);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      setProgress(await learningApi.progress(localDateKey()));
      setError(null);
    } catch (cause) {
      if (cause instanceof ApiError && cause.status === 401) onUnauthorized();
      else setError('Kunne ikke hente fremgangen din.');
    }
  }, [enabled, onUnauthorized]);

  useEffect(() => {
    if (!enabled) {
      setProgress(null);
      setError(null);
      return;
    }
    void refresh();
  }, [enabled, refresh]);

  const saveAttempt = useCallback(async (attempt: Omit<AttemptInput, 'localDate'>) => {
    try {
      await learningApi.saveAttempt({ ...attempt, localDate: localDateKey() });
      await refresh();
    } catch (cause) {
      if (cause instanceof ApiError && cause.status === 401) onUnauthorized();
      throw cause;
    }
  }, [onUnauthorized, refresh]);

  return { progress, error, refresh, saveAttempt };
}
